import { useLoadOptions } from "../../../../../hooks/useLoadOptions";

export const opcionesSiNo = [
  { id: 1, descripcion: 'Sí' },
  { id: 2, descripcion: 'No' }
];

export const useSiNoOptions = () => {
  return useLoadOptions({
    data: opcionesSiNo,
    loading: false,
    isError: false,
    error: null
  });
};

export const loadSiNoOptions = () => Promise.resolve(opcionesSiNo);